import React from "react";
import PropTypes from "prop-types";
import ButtonIcon from "../../components/buttons/buttonIcon";
import * as buttonConstants from "../../components/buttons/buttonConstants";
import ButtonBar from "../../components/buttons/buttonBar";
import * as config from "../../constants/config";

const ItemPoolListSearchRow = ({ itemPool, onEditItemPool, onDeleteItemPool }) => {
    const itemPoolLinkList = itemPool.Links.filter(f => f.Method === config.DELETE_API_METHOD);
    let itemPoolLinkInfo = {};
    if(itemPoolLinkList.length > 0)
        itemPoolLinkInfo = itemPoolLinkList[0];

    return (
        <tr>

            <td>{itemPool.Name}</td>
            <td className={"text-center"}>{itemPool.CatModelTypeDescription}</td>
            <td className={"text-center"}>
                <ButtonBar buttonBarPosition={buttonConstants.BUTTON_BAR_POSITION_CENTER}>
                    <ButtonIcon config={{
                        name: "btnEdit",
                        label: "Edit",
                        onClick: (event) => onEditItemPool(event, itemPool.Id),
                        iconType: buttonConstants.ICON_EDIT
                    }} />
                    <ButtonIcon config={{
                        name: "btnDelete",
                        label: (itemPoolLinkList.length === 0) ? "Delete not enabled due to being associated with a score" : "Delete",
                        disabled: (itemPoolLinkList.length === 0),
                        onClick: (event) => onDeleteItemPool(event, itemPoolLinkInfo),
                        iconType: buttonConstants.ICON_DELETE
                    }} />
                </ButtonBar>
            </td>
        </tr>
    );
};

ItemPoolListSearchRow.propTypes = {
    itemPool: PropTypes.object.isRequired,
    onEditItemPool: PropTypes.func.isRequired,
    onDeleteItemPool: PropTypes.func.isRequired
};

export default ItemPoolListSearchRow;